<template>

    <div class="athletes__grid" :class="{ 'is-child' : this.parent_page_id !== 0}">

        <div class="general__filters grid four">

            <div class="general__dropdown sports__dropdown" :class="{ 'french': this.lang == 'fr' }">
                <label class="vh" for="sportSelector">{{ printString('all_sports') }}</label>
                <select v-model="selectedSports" id="sportSelector" multiple="multiple">
                    <option v-for="sport in all_sports" :key="sport.ID" :value="sport.ID">{{ sport.post_title }}</option>
                </select>
            </div>

            <div class="general__dropdown games__dropdown" :class="{ 'french': this.lang == 'fr' }">
                <label class="vh" for="gameSelector">{{ printString('all_games') }}</label>
                <select v-model="selectedGames" id="gameSelector" multiple="multiple">
                    <option v-for="game in all_games" :key="game.id" :value="game.id">{{ game.title }}</option>
                </select>
            </div>

            <div class="general__dropdown empty-item"></div>

            <div class="general__search">
                <label class="vh" for="athleteSearch">{{ printString('search_athlete') }}</label>
                <input v-model="searchTerm" id="athleteSearch" type="search" :placeholder="printString('search_athlete')" @input="handleSearch"/>
            </div>

        </div>

        <div class="athletes__holder">

            <div class="athletes__loading" v-if="athletes.length === 0 && !loading">
                <h5>
                    {{ printString(  'no_athletes' ) }}
                </h5>
            </div>

            <ul class="grid four"  v-if="athletes.length === 0 && loading">
                <empty-block v-for="index in 12" :key="index"/>
            </ul>

            <ul class="grid four">
                <Block v-for="(single_athlete, index) in athletes" :key="single_athlete.id" :athlete="single_athlete" :id="'athlete-' + (index + 1)" />
            </ul>

            <button class="general-button grey-border" :class="{'inactive': loading }" @click="loadMore(true)" @keyup.enter="loadMore(true)" v-if="showLoadMore">

                <span class="loading_animation" v-if="loading"></span>
                <span v-html="ico_plus_16" v-else></span>

                <div v-if="loading"> {{printString('loading')}}  </div>
                <div v-else> {{printString('load_more')}} </div>

            </button>

        </div>

    </div>

</template>

<script>
import axios from 'axios';
import { reactive } from 'vue';
import 'select2/dist/js/select2.full.js'
import Block from './Block.vue';
import EmptyBlock from './EmptyBlock';

export default {
    components: {
        Block,
        EmptyBlock
    },
    data() {
      return {

        rest_url                        : window.php_data['rest_url'],
        lang                            : window.php_data['lang'],
        parent_page_id                  : window.php_data['parent_page_id'],
        all_sports                      : window.php_data['all_sports'],
        all_games                       : window.php_data['all_games'],
        athletes                        : [],
        old_athlete                     : [],

        selectedSports                  : [],
        selectedGames                   : [],
        searchTerm                      : '',

        showLoadMore                    : true,
        totalPages                      : 1,
        reseting                        : false,
        loading                         : true, // add loading state
        page                            : 1, // Initial page
        perPage                         : 16, // Number of posts to fetch per page
        sortedBy                        : "title",
        orderAsc                        : "asc",
        athlete_type                    : [],

        isFirstLoad                     : true,
        searchTimeout                   : null, // Variable to hold the timeout reference

        arrow_right_alt                 : window.arrow_right_alt,
        ico_plus_16                     : window.ico_plus_16,

      };
    },

    computed: {

    },

    mounted() {
        let vm = this;
        
        this.initializeSelects();

        // Parse the URL to check for sport_id parameter
        const urlParams = new URLSearchParams(window.location.search);
        const sportId = urlParams.get('sport_id');

        // If 'area' parameter is present, update selectedImpact
        if (sportId) {
            const sports = sportId.split(',');
            vm.selectedSports = sports;

            // Trigger change event to update the select2 dropdown
            jQuery('#sportSelector').val(sports).trigger('change.select2');
        }


        this.loadMore().then(() => {
            this.isFirstLoad = false; // Set to false after the initial load
        });

        // Watch for changes in selectedImpact and update the URL
        this.$watch(
            () => this.selectedSports,
            (newSport) => {
                const queryParams = new URLSearchParams(window.location.search);
                if (newSport.length > 0) {
                    queryParams.set('sport_id', newSport.join(','));
                } else {
                    queryParams.delete('sport_id');
                }
                const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
                window.history.pushState(null, '', newUrl);
                // this.resetOnSelect();
            },
            { immediate: false, deep: true }
        );
    },


    methods: {

        resetOnSelect(){
            this.reseting = true
            this.loading = true

            this.loadMore();
        },

        async loadMore(isUserTriggered = false) {

            this.loading = true;
            if( this.reseting ){
                this.page = 1
            }

            const response = await this.fetchAthletePosts();

            // Check if the received data is already present in the awards array
            const newData = response.data.filter(item => !this.athletes.find(existingItem => existingItem.id === item.id));

            // Track the index of the first new element
            const firstNewIndex = this.athletes.length;

            // Concatenate only the new data
            this.athletes = this.athletes.concat(newData);

            if( isUserTriggered && !this.isFirstLoad ){
                // Use nextTick to ensure DOM update before focusing
                this.$nextTick(() => {
                    if (newData.length > 0) {
                        const firstNewElement = document.getElementById(`athlete-${firstNewIndex + 1}`);
                        if (firstNewElement) {
                            console.log(firstNewElement);
                            firstNewElement.scrollIntoView({ behavior: 'smooth' });
                            // Make the element focusable
                            firstNewElement.setAttribute('tabindex', '-1');
                            firstNewElement.focus();
                        }
                    }
                });
            }

            // Update showLoadMore flag based on the length of the new data
            this.showLoadMore = response.data.length >= this.perPage;

            // Check if all pages are loaded
            if (this.page == response.headers['x-wp-totalpages']) {
                this.showLoadMore = false;
            }

            this.page++;

        },
        async fetchAthletePosts() {
            try {
                const params = {
                    // order: this.orderAsc,
                    // orderby: this.sortedBy,
                    page: this.page,
                    per_page: this.perPage,
                    lang: window.php_data['lang'],
                };

                // Only include athlete_type parameter if it's not empty
                if (this.selectedGames !== "") {
                    params.athlete_games = this.selectedGames.join(',');
                }

                if (this.selectedSports !== "") {
                    params.athlete_sports = this.selectedSports.join(',');
                }

                if (this.searchTerm.trim() !== '') {
                    params.search = this.searchTerm.trim();
                }

                if( this.parent_page_id !== "" ){
                    params.game_hub = this.parent_page_id;
                }

                const response = await axios.get(`${this.rest_url}/wp-json/wp/v2/athlete`, { params });

                if( this.reseting ){
                    this.athletes = []
                }

                this.reseting = false;
                this.loading = false;

                return response;
            } catch (error) {
                console.error('Error fetching athlete posts:', error);
                return [];
            }
        },

        printString( string ){
            return window.translations[string]
        },

        handleSearch() {
            clearTimeout(this.searchTimeout); // Clear the previous timeout
            this.searchTimeout = setTimeout(() => {
                this.resetOnSelect(); // Make the request after the user stops typing
            }, 500); // Adjust the delay as needed
        },

        initializeSelects(){

            let vm = this
            //===========================SPORTS SELECTOR==============================

            jQuery('#sportSelector').select2({
                width: '100%',
                templateSelection: function(data){
                    let selectedOptions = jQuery( '#sportSelector' ).select2('data')

                    let output = '(' + selectedOptions.length + ') '

                    selectedOptions.forEach( function( item ) {
                        output += item.text

                        if( selectedOptions.length > 1 )
                            output += ', '
                    })

                    if( selectedOptions.length > 1 || output.length > 15 )
                        output = output.substring(0, 15) + '...'

                    return '<span tabindex="0">'+output+'</span>'

                },
                allowClear: true,
                placeholder: vm.printString('all_sports'),
                escapeMarkup: function(m) {
                    return m
                },
            }).on('select2:clear', function () {

                vm.clearing_filter = true
                const selectedSports = jQuery(this).val();
                vm.selectedSports = selectedSports;
                vm.resetOnSelect();
                var self = jQuery(this);
                setTimeout(function() {
                    self.select2('close');
                }, 1);

            }).on('select2:selecting', function () {

                vm.clearing_filter = false

            }).on('change', function () {
                var self = jQuery(this)
                if(self.val().length > 0){
                    jQuery('.select2-selection__clear').attr('tabindex', 0);
                    jQuery('.select2-selection__clear').on('keydown', function(e) {
                        if (e.keyCode === 13) { // Enter key
                            // Clear the selection
                            jQuery('#sportSelector').val(null).trigger('change');
                        }
                    });
                }
                if(!vm.clearing_filter ){
                    const selectedSports = jQuery(this).val();
                    vm.selectedSports = selectedSports;
                    vm.resetOnSelect();
                }

            }).on('select2:unselect', function (e) {
                const removedOption = e.params.data;
                vm.selectedSports = vm.selectedSports.filter(id => id !== removedOption.id);
                vm.resetOnSelect();
            }).on('keyup', function (e) {
                // Check if the key pressed is Enter (key code 13)
                if (e.keyCode === 13) {
                    const removedOption = jQuery(this).select2('data')[0];
                    vm.selectedSports = vm.selectedSports.filter(id => id !== removedOption.id);
                    vm.resetOnSelect();
                }
            });

            // Add the readonly attribute to the select2-search__field input
            const searchField1 = jQuery('#sportSelector').next().find('.select2-search__field');
            searchField1.attr('readonly', 'readonly');
            // Set the ID attribute for the search field input
            searchField1.attr('id', 'sportSelectorSearch');
            // Create a label element
            const labelForSearchField1 = jQuery('<label class="vh">').attr('for', 'sportSelectorSearch').text(this.printString('all_sports'));
            // Insert the label before the input field
            searchField1.before(labelForSearchField1);

            //===========================GAMES SELECTOR==============================

            jQuery('#gameSelector').select2({
                width: '100%',
                templateSelection: function(data){
                    let selectedOptions = jQuery( '#gameSelector' ).select2('data')

                    let output = '(' + selectedOptions.length + ') '

                    selectedOptions.forEach( function( item ) {
                        output += item.text

                        if( selectedOptions.length > 1 )
                            output += ', '
                    })

                    if( selectedOptions.length > 1 || output.length > 15 )
                        output = output.substring(0, 15) + '...'

                    return '<span tabindex="0">'+output+'</span>'

                },
                allowClear: true,
                placeholder: vm.printString('all_games'),
                escapeMarkup: function(m) {
                    return m
                },
            }).on('select2:clear', function () {

                vm.clearing_filter = true
                const selectedGames = jQuery(this).val();
                vm.selectedGames = selectedGames;
                vm.resetOnSelect();

                var self = jQuery(this);
                setTimeout(function() {
                    self.select2('close');
                }, 1);

            }).on('select2:selecting', function () {

                vm.clearing_filter = false

            }).on('change', function () {
                var self = jQuery(this)
                if(self.val().length > 0){
                    jQuery('.select2-selection__clear').attr('tabindex', 0);
                    jQuery('.select2-selection__clear').on('keydown', function(e) {
                        if (e.keyCode === 13) { // Enter key
                            // Clear the selection
                            jQuery('#gameSelector').val(null).trigger('change');
                        }
                    });
                }
                if(!vm.clearing_filter ){
                    const selectedGames = jQuery(this).val();
                    vm.selectedGames = selectedGames;
                    vm.resetOnSelect();
                }

            })

            // Add the readonly attribute to the select2-search__field input
            const searchField2 = jQuery('#gameSelector').next().find('.select2-search__field');
            searchField2.attr('readonly', 'readonly');
            // Set the ID attribute for the search field input
            searchField2.attr('id', 'gameSelectorSearch');
            // Create a label element
            const labelForSearchField2 = jQuery('<label class="vh">').attr('for', 'gameSelectorSearch').text(this.printString('all_games'));
            // Insert the label before the input field
            searchField2.before(labelForSearchField2);


        },
    }
};
</script>
